const system_limit = {
    limit_exceeded: '시스템 한도에 도달했습니다. 지원팀에 문의해 도움을 받으세요.',
};
export default Object.freeze(system_limit);
